import { MiscType } from './misc-data.type';
import { selectedSender, setSendersListPageDetails } from './misc-data.action';


const INITIAL_STATE = {
    phone: "",
    selectedConsumers: [],
    deviceInfo: "",
    currentBatch: '',
    selectedAmount: '',
    batchConsumers: [],
    selecetDueDate: '',
    startDate: '',
    endDate: '',
    rowSelected: '',
    consumerAddResp: '',
    activeLinkStatus: '',
    transferTotalAmount: '',
    billListConsumers: [],
    billListStartIndex: '',
    billListEndIndex: '',
    totalDueList: [],
    billListAmount: 0,
    billListKeys: [],
    token: '',
    agentInfo: '',
    consumerProfile: '',
    fullName: '',
    businessName: '',
    consumerAgent: '',

    stateList: [],
    cityList: [],
    branchList: [],
    ifscCode: '',

    selectedBankName: '',
    selectedBankId: '',
    selectedBankDetails: '',
    generateOtpResponse: '',
    branchAddress: '',

    activeStatus: '',
    loginTime: Date,
    txmAmnt: '',
    txnSurchrg: '',
    txnTotalAmnt: '',

    txnHistoryResponse: [],
    customerLimit: '',

    exportData: '',
    totalElementsNo: 0,
    txnPaginationResponse: '',
    bankLogoListTxt: '',

    graphResponse: '',

    partner: '',
    clientRequesterId: '',
    logoName: '',
    clientRole: '',
    taLoadPermission: '',
    claimResp: '',

    toDate: '',
    formDate: '',
    callBackUrl: '',
    claimResp: '',

    retailerBalanceShow: '',
    claimLoadShow: '',
    retailerBalanceValue: 0,
    graphMonth: '3',

    timeoutModal: '',
    showAll: '',
    service: '',
    totalConsumers: 'Loading',
    actives: 0,
    inActives: 0,
    logOutEnabled:''

};

const miscReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        //here start
        case MiscType.setConsumerProfile:
            return {
                ...state,
                consumerProfile: action.payload,
            };
        case MiscType.setFullName:
            return {
                ...state,
                fullName: action.payload,
            };
        case MiscType.setBusinessName:
            return {
                ...state,
                businessName: action.payload,
            };
        case MiscType.setAgentId:
            return {
                ...state,
                consumerAgent: action.payload,
            };
        case MiscType.selectedConsumerList:
            return {
                ...state,
                selectedConsumers: action.payload,
            };
        case MiscType.setTotalDueList:
            return {
                ...state,
                totalDueList: action.payload,
            };
        case MiscType.setBatch:
            return {
                ...state,
                currentBatch: action.payload,
            };
        case MiscType.selectedRow:
            return {
                ...state,
                rowSelected: action.payload,
            };


        case MiscType.setSelectedAmount:
            return {
                ...state,
                selectedAmount: action.payload,
            };
        case MiscType.setBatchConsumers:
            return {
                ...state,
                batchConsumers: action.payload,
            };
        case MiscType.setBatchConsumers:
            return {
                ...state,
                batchConsumers: action.payload,
            };
        case MiscType.totalConsumerNo:
            return {
                ...state,
                totalConsumers: action.payload,
            };
        case MiscType.totalActiveConsumers:
            return {
                ...state,
                actives: action.payload,
            };
        case MiscType.totalInActiveConsumers:
            return {
                ...state,
                inActives: action.payload,
            };

        case MiscType.selectDueDate:
            return {
                ...state,
                selecetDueDate: action.payload,
            };
        case MiscType.setStartDate:
            return {
                ...state,
                startDate: action.payload,
            };
        case MiscType.setEndDate:
            return {
                ...state,
                endDate: action.payload,
            };
        case MiscType.setConsumerAddresp:
            return {
                ...state,
                consumerAddResp: action.payload,
            };
        case MiscType.setBillListConsumers:
            return {
                ...state,
                billListConsumers: action.payload,
            };
        case MiscType.setBillListStartIndex:
            return {
                ...state,
                billListStartIndex: action.payload,
            };
        case MiscType.setBillListEndIndex:
            return {
                ...state,
                billListEndIndex: action.payload,
            };
        case MiscType.setBillListTotalAmount:
            return {
                ...state,
                billListAmount: action.payload,
            };
        case MiscType.setBillListKeys:
            return {
                ...state,
                billListKeys: action.payload,
            };


        case MiscType.setDeviceInfo:
            return {
                ...state,
                deviceInfo: action.payload,
            };

        case MiscType.setToken:
            return {
                ...state,
                token: action.payload,
            };
        case MiscType.setAgentInfo:
            return {
                ...state,
                agentInfo: action.payload,
            };




        case MiscType.setStateDetails:
            return {
                ...state,
                stateList: action.payload,
            };

        case MiscType.setCityList:
            return {
                ...state,
                cityList: action.payload,
            };
        case MiscType.setBranchList:
            return {
                ...state,
                branchList: action.payload,
            };
        case MiscType.setIfscCode:
            return {
                ...state,
                ifscCode: action.payload,
            };

        case MiscType.setBankDetails:
            return {
                ...state,
                bankDetails: action.payload,
            };

        case MiscType.setSelectedBankName:
            return {
                ...state,
                selectedBankName: action.payload,
            };

        case MiscType.setSelectedBankId:
            return {
                ...state,
                selectedBankId: action.payload,
            };

        case MiscType.setSelecetedBankDetails:
            return {
                ...state,
                selectedBankDetails: action.payload,
            };




        case MiscType.setBranchAddress:
            return {
                ...state,
                branchAddress: action.payload,
            };


        case MiscType.selectedSender:
            return {
                ...state,
                selectSender: action.payload,
            };




        case MiscType.setActiveStatus:
            return {
                ...state,
                activeStatus: action.payload,
            };

        case MiscType.setLogOutWarningStatus:
            return {
                ...state,
                logOutWarningStatus: action.payload,
            };

        case MiscType.setLoginTimestamp:
            return {
                ...state,
                loginTime: action.payload,
            };

        case MiscType.setTxnAmount:
            return {
                ...state,
                txmAmnt: action.payload,
            };

        case MiscType.setTxnsurcharge:
            return {
                ...state,
                txnSurchrg: action.payload,
            };

        case MiscType.setTxntotalAmount:
            return {
                ...state,
                txnTotalAmnt: action.payload,
            };

        case MiscType.setMoneyTransferProgress:
            return {
                ...state,
                moneyTransferProgress: action.payload,
            };

        case MiscType.setStatusEnqResponse:
            return {
                ...state,
                createOrderStatusResponse: action.payload,
            };


        case MiscType.setTxnHistoryResponse:
            return {
                ...state,
                txnHistoryResponse: action.payload,
            };


        case MiscType.setCustomerLimit:
            return {
                ...state,
                customerLimit: action.payload,
            };

        case MiscType.selectedBeneList:
            return {
                ...state,
                selecetdBenefisciaries: action.payload,
            };

        case MiscType.setTxnReportingData:
            return {
                ...state,
                exportData: action.payload,
            };

        case MiscType.setTxnHistoryElementNo:
            return {
                ...state,
                totalElementsNo: action.payload,
            };

        case MiscType.setTxnHistoryPaginationResponse:
            return {
                ...state,
                txnPaginationResponse: action.payload,
            };

        case MiscType.setTotalSenders:
            return {
                ...state,
                totalSenders: action.payload,
            };

        case MiscType.setSendersListPageDetails:
            return {
                ...state,
                senderListPageDetails: action.payload,
            };

        case MiscType.setBankLogoList:
            return {
                ...state,
                bankLogoListTxt: action.payload,
            };

        case MiscType.setSenderCustomerId:
            return {
                ...state,
                senderCustomerId: action.payload,
            };

        case MiscType.setBeneCustomerId:
            return {
                ...state,
                beneCustomerId: action.payload,
            };

        case MiscType.setGraphResponse:
            return {
                ...state,
                graphResponse: action.payload,
            };
        case MiscType.setOtpForBeneVerification:
            return {
                ...state,
                beneVerifyOtp: action.payload,
            };
        case MiscType.setBeneRegister:
            return {
                ...state,
                beneRegisterResponse: action.payload,
            };

        case MiscType.setPartner:
            return {
                ...state,
                partner: action.payload,
            };
        case MiscType.setRequesterId:
            return {
                ...state,
                clientRequesterId: action.payload,
            };
        case MiscType.setLogoName:
            return {
                ...state,
                logoName: action.payload,
            };
        case MiscType.setClientRole:
            return {
                ...state,
                clientRole: action.payload,
            };

        case MiscType.setTaLoadPermission:
            return {
                ...state,
                taLoadPermission: action.payload,
            };

        case MiscType.setFilterEndDate:
            return {
                ...state,
                toDate: action.payload,
            };
        case MiscType.setFilterStartDate:
            return {
                ...state,
                formDate: action.payload,
            };
        case MiscType.setMiscCallBackUrl:
            return {
                ...state,
                callBackUrl: action.payload,
            };
        case MiscType.setClaimResp:
            return {
                ...state,
                claimResp: action.payload,
            };

        case MiscType.setRetailerBlance:
            return {
                ...state,
                retailerBalanceValue: action.payload,
            };
        case MiscType.setClaimLoadShow:
            return {
                ...state,
                claimLoadShow: action.payload,
            };

        case MiscType.setRetailerBalanceVal:
            return {
                ...state,
                retailerBalanceValue: action.payload,
            };
        case MiscType.setDashboardPageGraphMonth:
            return {
                ...state,
                graphMonth: action.payload,
            };
        case MiscType.setTimeoutModal:
            return {
                ...state,
                timeoutModal: action.payload,
            };
        case MiscType.setShowAll:
            return {
                ...state,
                showAll: action.payload,
            };
        case MiscType.setService:
            return {
                ...state,
                service: action.payload,
            };
            case MiscType.setLogoutEnabled:
                return {
                    ...state,
                    logOutEnabled: action.payload,
                };


        case MiscType.RESET:
            return INITIAL_STATE;
        default:
            return state;
    }

};

export default miscReducer; 